import Link from 'next/link'
import { getTranslations } from 'next-intl/server'

export async function NotFound() {
  const t = await getTranslations('Ui.NotFound')
  return (
    <main className='flex min-h-screen flex-col items-center justify-center bg-gray-100 px-6 text-center'>
      <div className='max-w-md'>
        <h1 className='text-6xl font-bold text-gray-900'>404</h1>
        <p className='mt-4 text-xl text-gray-700'>{t('Title')}</p>
        <p className='mt-2 text-sm text-gray-500'>{t('Description')}</p>
        <Link
          href='/'
          className='mt-6 inline-block rounded bg-blue-600 px-5 py-2 text-white hover:bg-blue-700'
        >
          {t('BackToHome')}
        </Link>
      </div>
    </main>
  )
}
